import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./OpeningHoursFixModal.css";
import Common from "../../Common/Common";

// Opened from SchedulePanel.js's/ScheduleHeader.js's idle-time alert (see
// reportIdleTime) — offers the guide's own unused places as one-tap
// additions to fill real leftover time at the end of a day, instead of
// leaving the user to search and add them manually. Reuses
// OpeningHoursFixModal's visual language (same CSS classes) since it's the
// same "pick a place from a list" shape, just adding a new event instead of
// substituting an existing one's place. Only offers places already in the
// guide (Schedule.findFillCandidates) — no live/paid search tier here, see
// this component's own scope note in SchedulePanel.js. Found 2026-09-30.
const FillIdleTimeModal = ({ show, onHide, dayLabel, remainingMinutes, candidates, onAdd }) => {
  if (!show) return null;

  return (
    <div className="modal">
      <Modal show={show} onHide={onHide} animation={false} dialogClassName="ohf-dialog" aria-labelledby="fit-title" centered>
        <Modal.Body style={{ padding: 0 }}>
          <div className="ohf-shell">
            <div className="ohf-header">
              <div className="ohf-header-icon">
                <FontAwesomeIcon icon={solid("calendar-plus")} />
              </div>
              <h2 className="ohf-title" id="fit-title">Fill free time</h2>
              <button className="ohf-close" onClick={onHide}>
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            <div className="ohf-body">
              <p className="ohf-message">
                {dayLabel} has about {Common.formatTravelDuration(Math.max(0, Math.round(remainingMinutes)))} left before day-end.
                {candidates.length > 0 ? " Tap a place to add it." : ""}
              </p>

              {candidates.length === 0 ? (
                <p className="ohf-message">
                  No unused places in your guide fit here — try AI Search on the map to add more places, then check back.
                </p>
              ) : (
                <div className="ohf-candidate-list">
                  {candidates.map((p) => (
                    <button key={p.ID} className="ohf-option" onClick={() => onAdd(p)}>
                      <span className="ohf-option-title">{p.Name}</span>
                      <span className="ohf-option-sub">
                        {Common.formatTravelDuration(p.Duration || 90)} visit
                        {p.Rating ? ` · ★ ${p.Rating}` : ""}
                      </span>
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="ohf-footer">
              <button className="ohf-btn ohf-btn-cancel" onClick={onHide}>Done</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FillIdleTimeModal;
